import React from 'react'

const DetalheBagagem = ({ bagagem }) => {
  if (!bagagem?.exibirDetalhe) {
    return null
  }

  return (
    <div className="detalhe-bagagem card mt-2 p-3">
      <h5>Detalhes da Bagagem</h5>
      <div className="row">
          <div className="col">
            <span className="titulo-mobile">Tipo de cálculo:&nbsp;</span>
            {bagagem.descTipoCalculoBagagem}
          </div>
        <div className="col">
          <strong>Formas de Pagamento:</strong>
          {bagagem.formasPagamento && bagagem.formasPagamento.length > 0 ? (
            <>
              {bagagem.formasPagamento.map((fp, index) => (
                <div className="row mb-2" key={index}>
                  <div className="col">
                    <strong>Valor pago:</strong>{' '}
                    {fp.tipo}:{' '}
                    {fp.valor.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </div>
                  <div className="col">
                    <strong>Qtd Parcelas:</strong> {fp.quantidadeParcelas}
                  </div>
                  <div className="col">
                    <strong>Passageiro:</strong> {bagagem.nomePassageiro}
                  </div>
                </div>
              ))}
            </>
          ) : (
            <span> Nenhuma informada </span>
          )}
        </div>
      </div>

    </div>
  )
}

export default DetalheBagagem
